import { styled } from "styled-components";
import Footer from "./Footer";
import Header from "./Header";
import CategoriesBar from "./CategoriesBar";
import { useLocation } from "react-router-dom";

function Layout(props) {
  const location = useLocation();
  return (
    <section>
      <Header />
      {location.pathname.includes("blogs") && (
        <Subnav className="layoutWrapper">
          <CategoriesBar />
        </Subnav>
      )}
      <Main>{props.children}</Main>
      <Footer />
    </section>
  );
}

export default Layout;

const Main = styled.main`
  min-height: calc(100vh - 200px);
`;

const Subnav = styled.nav`
  display: flex;
  justify-content: right;
`;
